module.exports = __webpack_public_path__ + "img/americanexpress.48fc0469.png";